import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  useCases: [],
  metrics: [],
  applicationSummary: {},
  trustWeights: {},
  risks: [],
  uploadedFiles: [],
  selectedUseCases: [],
  qaData: [],
  loading: false,
  error: null,
};

const datasetSlice = createSlice({
  name: 'dataset',
  initialState,
  reducers: {
    setUseCases: (state, action) => {
      state.useCases = action.payload;
    },
    setMetrics: (state, action) => {
      state.metrics = action.payload;
    },
    setApplicationSummary: (state, action) => {
      state.applicationSummary = action.payload;
    },
    setTrustWeights: (state, action) => {
      state.trustWeights = action.payload;
    },
    setRisks: (state, action) => {
      state.risks = action.payload;
    },
    setUploadedFiles: (state, action) => {
      state.uploadedFiles = action.payload;
    },
    addUploadedFile: (state, action) => {
      state.uploadedFiles.push(action.payload);
    },
    removeUploadedFile: (state, action) => {
      state.uploadedFiles = state.uploadedFiles.filter((_, index) => index !== action.payload);
    },
    setSelectedUseCases: (state, action) => {
      state.selectedUseCases = action.payload;
    },
    toggleSelectedUseCase: (state, action) => {
      const useCase = action.payload;
      const index = state.selectedUseCases.findIndex(uc => uc.title === useCase.title);
      if (index >= 0) {
        state.selectedUseCases.splice(index, 1);
      } else {
        state.selectedUseCases.push(useCase);
      }
    },
    setQaData: (state, action) => {
      state.qaData = action.payload;
    },
    setDatasetData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetDataset: () => initialState,
  },
});

export const {
  setUseCases,
  setMetrics,
  setApplicationSummary,
  setTrustWeights,
  setRisks,
  setUploadedFiles,
  addUploadedFile,
  removeUploadedFile,
  setSelectedUseCases,
  toggleSelectedUseCase,
  setQaData,
  setDatasetData,
  setLoading,
  setError,
  resetDataset,
} = datasetSlice.actions;

export default datasetSlice.reducer;
